export const getUserProfile = () => {
  return localStorage.getItem("user_profile") || null;
};
